import type {ApiRequestMeta, ApiRpcRequestParams, RpcRequest} from './types';

import {flatExpand} from '../expand';
import {prepareQuery} from './prepareQuery';
import {requestState} from './state';

export const makeRpcRequestObj = <
  P extends ApiRpcRequestParams = ApiRpcRequestParams,
>({
  method,
  options,
  params,
}: RpcRequest<P>) => {
  const meta: ApiRequestMeta = {};

  if (options) {
    if (options.withAuth && !method.startsWith('public.')) {
      meta.access_token = requestState.accessToken;
    }

    if (options.withVersion) {
      meta.version = (options.version || requestState._apiVersion)
        .split('.')
        .map(x => +x);
    }

    if (options.captcha) {
      meta.token = options.captcha;
    }
  }

  let paramsToSend: P;

  if (params) {
    paramsToSend = JSON.parse(JSON.stringify(params)) as P;

    if (params.expand) {
      paramsToSend.expand = flatExpand(params.expand);
    }

    if (params.query) {
      paramsToSend.query = prepareQuery(params.query);
    }
  }

  // @ts-expect-error: TODO: describy why
  const request: ApiRpcRequest<P> = {meta, method, params: paramsToSend};

  if (options && !options.notify) {
    requestState.id += 1;
    request.id = requestState.id;
  }

  return request;
};
